import styled from "styled-components";
import { Heading1, SubHeading, CTAButtonWrapper } from "../../../../common/styled-components/styled-components";
import { device, breakpoints } from '../../../../../../app/js/utils/responsive_utilities';
import { white, whiteLilac } from '../../../../../../app/js/components/loggedout/shared-styles/Colors';
import { styledFont } from '../../../../common/mixins/mixin';
import { moveElementHorizontally } from "../../../../common/functions/animations";

export const ContainerWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #090A4A;
  ${styledFont("Graphie")}
  padding: 8.6rem 0 7rem 0;

  @media (min-width:${breakpoints.md}px){
    padding: 8.6rem 0 20rem 0;
  }
`

export const HeadingText = styled(Heading1)`
  color: ${white};
  margin: auto;
  padding-top: 0.5rem;
  ${styledFont("Graphie", 3.2, 3.8, 7)}

  @media ${device.Tablet}{
    width: 60%;
  }
  
  @media ${device.Desktop}{
    ${styledFont("Graphie", 4.8, 6.4, 7)}
    width: 50%;
  }
`

export const HighlightText = styled.span`
  color: #4F52C3;
`

export const PlayableWrapper = styled.div`
  margin: 6.7rem 0 8.1rem 0;

  @media ${device.Tablet}{
    margin: 4.4rem 0 3.7rem 0;
  }

  @media ${device.Desktop}{
    margin: 3.4rem 0 7rem 0;
  }
  
`

export const PlayableGroupFirst = styled.div`
  height: 100%;
  transform: rotate(-4deg);
  margin-bottom: 1.6rem;

  > img{
    height: 100%;
    width: calc(100% + 16rem);
    animation: ${moveElementHorizontally({x1: -10, x2: -7})} 2s linear 1 forwards;
  }

  @media (min-width:${breakpoints.md}px){
    height: 100%;
    >img{
      width: calc(100% + 17rem);
      animation: ${moveElementHorizontally({x1: -10, x2: -6})} 2s linear 1 forwards;
    }
  }

  @media ${device.Desktop}{
    margin-bottom: 3.2rem;
  }
`

export const PlayableGroupSecond = styled.div`
  height: 100%;
  transform: rotate(-4deg);

  > img{
    height: 100%;
    width: calc(100% + 14rem);
    animation: ${moveElementHorizontally({x1: -10, x2: -13})} 2s linear 1 forwards;
  }

  @media (min-width:${breakpoints.md}px){
    height: 100%;
    >img{
      width: calc(100% + 15rem);
      animation: ${moveElementHorizontally({x1: -10, x2: -14})} 2s linear 1 forwards;
    }
  }
`

export const ButtonWrapper = styled(CTAButtonWrapper)`
  padding-bottom: 10rem;
  >div {
    width: 30rem;
  }
  @media ${device.Desktop}{
    padding-bottom: 5rem;
  }
`